// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PlO_","top":"styles_top__10XAY"};